// imports
import { JSX, PropsWithChildren } from 'react';

// styles
import styles from './PageTransition.module.scss';

type PageTransitionProps = {
  fallbackSpacing?: boolean;
};

const PageTransition = ({
  children,
  fallbackSpacing = false,
}: PropsWithChildren<PageTransitionProps>): JSX.Element => {
  return (
    <div className={`${styles.page_transition} ${fallbackSpacing ? styles.fallback_spacing : ''}`}>
      {children}
    </div>
  );
};

export default PageTransition;
